/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Usecases_PrevInputs */

const es_home_usecases_prev = /** @type {(inputs: Home_Usecases_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anterior`)
};

const en_home_usecases_prev = /** @type {(inputs: Home_Usecases_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prev`)
};

/**
* | output |
* | --- |
* | "Prev" |
*
* @param {Home_Usecases_PrevInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_usecases_prev = /** @type {((inputs?: Home_Usecases_PrevInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Usecases_PrevInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_usecases_prev(inputs)
	return en_home_usecases_prev(inputs)
});
export { home_usecases_prev as "home.usecases.prev" }